import React, { useEffect, useState } from "react";
import Upload from "../Upload/Upload";
import Masonry from "react-masonry-css";
import Style from "./Board.module.scss";
import "./grid.css";
import Navbar from "../Navbar/Navbar";

import { deleteDoc } from "firebase/firestore";
import { storage } from "../../firebase";
import { deleteObject, ref, refFromURL } from "firebase/storage";

// new
import { auth, logout, db } from "../../firebase";
import {
	query,
	collection,
	getDoc,
	// where,
	orderBy,
	onSnapshot,
	doc,
} from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const Board = () => {
	const [data, setData] = useState([]);

	const [modal, setModal] = useState(false);
	const [currentImg, setCurrentImg] = useState(null);

	const [userDetails, setUserDetails] = useState(null);

	const [user, loading, error] = useAuthState(auth);
	const navigate = useNavigate();

	useEffect(() => {
		if (loading) return;
		if (!user) return navigate("/");

		// fetchUsername()
		const fetchUsername = async () => {
			const currentUser = await getDoc(doc(db, `users/${user?.uid}`));
			// console.log(currentUser.data())
			setUserDetails(currentUser.data());
		};

		fetchUsername();
	}, [user, loading]);

	useEffect(() => {
		// Todo
		if (loading) return;
		const userImgPath = `users/${user?.uid}/images`;
		// const userImgPath = `users/${uid}/images`
		const q = query(collection(db, userImgPath), orderBy("dateAdded", "desc"));

		onSnapshot(q, (querySnapshot) => {
			setData(
				querySnapshot.docs.map((doc) => ({
					id: doc.id,
					data: doc.data(),
				}))
			);
		});
	}, [loading]);

	const handleImageClick = (s) => {
		setCurrentImg(s);
		setModal(!modal);
	};

	// useEffect(() => {

	// },[modal])
	const handleDelete = async () => {
		setModal(false);
		console.log(currentImg);
		console.log(`users/${user?.uid}/images/${currentImg.data.fileName}`);
		await deleteDoc(doc(db, `users/${user?.uid}/images/${currentImg.id}`));
		toast.success("Image deleted successfully");
		const imageref = ref(storage, `files/${currentImg.data.fileName}`);
		deleteObject(imageref).catch((error) => {
			toast.error("Uh-oh, an error occurred!");
		});
	};

	return (
		<>
			<div
				style={{ backgroundColor: modal ? "#000" : "" }}
				className={Style.container}
			>
				{/* <div>{user?.displayName}</div> */}

				{currentImg && (
					<div
						className={modal ? `${Style.showModal}` : `${Style.hideModal}`}
						onClick={() => setModal(!modal)}
					>
						<div className={Style.overlay}>
							<div
								className={Style.modal}
								onClick={(e) => {
									// do not close modal if anything inside modal content is clicked
									e.stopPropagation();
								}}
							>
								{/* <div className={Style.photo}> */}
								{console.log(currentImg)}
								<div className={Style.image}>
									<img src={currentImg.data.imgURL} alt="" />
								</div>
								{/* </div> */}
								<div className={Style.info}>
									<div onClick={() => setModal(false)} className={Style.close}>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											strokeWidth="2"
											strokeLinecap="round"
											strokeLinejoin="round"
											// class="ai ai-Cross"
										>
											<path d="M20 20L4 4m16 0L4 20" />
										</svg>
									</div>
									<div className={Style.contain}>
										{/* <div className={Style.head}>Saved 1day ago</div> */}
										{/* <div className={Style.notes}>
											<div className={Style.title}>NOTES</div>
											<input className={Style.box} />
										</div> */}
									</div>
									<button onClick={handleDelete} className={Style.delete}>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											strokeWidth="2"
											strokeLinecap="round"
											strokeLinejoin="round"
											// class="ai ai-TrashCan"
										>
											<path d="M4 6h16l-1.58 14.22A2 2 0 0 1 16.432 22H7.568a2 2 0 0 1-1.988-1.78L4 6z" />
											<path d="M7.345 3.147A2 2 0 0 1 9.154 2h5.692a2 2 0 0 1 1.81 1.147L18 6H6l1.345-2.853z" />
											<path d="M2 6h20" />
											<path d="M10 11v5" />
											<path d="M14 11v5" />
										</svg>
									</button>
								</div>
							</div>
						</div>
					</div>
				)}
				<Navbar logout={logout} userDetails={userDetails} />

				<Masonry
					breakpointCols={{
						default: 5,
						1700: 4,
						1500: 3,
						1100: 3,
						700: 2,
						500: 2,
					}}
					className={`${Style.grid}`}
					columnClassName={"grid__column"}
				>
					{/* array of JSX items */}
					<Upload user={user} />
					{data.map((s) => (
						<div key={s.id} className={Style.card}>
							<img
								src={s.data.imgURL}
								alt=""
								className={Style.uploaded}
								onClick={() => handleImageClick(s)}
							/>
						</div>
					))}
				</Masonry>
			</div>
		</>
	);
};

export default Board;
